module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('ul', {
    staticClass: "content"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'SubjectView',
          params: {
            classify: item.subtype ? item.subtype : 'book',
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "group-meta"
    }, [(item.images.small) ? _c('img', {
      attrs: {
        "src": item.images.small,
        "alt": "cover"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "group-info"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.rating) ? _c('rating', {
      attrs: {
        "rating": item.rating
      }
    }) : _vm._e()], 1), _vm._v(" "), (item.group_member) ? _c('span', {
      staticClass: "group-member"
    }, [_vm._v("20005人")]) : _vm._e()]), _vm._v(" "), (item.group_topic) ? _c('div', {
      staticClass: "group-topic"
    }, [_c('span', [_vm._v(_vm._s(item.group_topic.time))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.group_topic.title))])]) : _vm._e()])], 1)
  })), _vm._v(" "), _vm._t("more")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c738e9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Group.vue
// module id = 199
// module chunks = 0